import React, { useEffect, useState } from "react";
import "react-resizable/css/styles.css";
import "./Table.css";
import Canvas, { CANVAS_CONSTANT } from "./Canvas";
import useUserStore from "../../stores/store";
import ApiService from "../../utils/ApiService";
import { useNavigate } from "react-router-dom";
import ShowOrderModal from "../modals/ShowOrderModal";
import useTableManagementStorage from "../../stores/useTableManamentStore";
import {
  getSelectedTableIds,
  isCleanableATable,
  tableCleanRequestSubmit,
} from "../../services/order-table-base-service";
import { SELECTED_TABLE_STATUS } from "../../constant/constants";
import { addSelectedTablesInStore, handleMultiActionsOnTableModal, replaceSelectedTablesInStore, updateFloorTabActiveKey } from "../../utils/store-mutator.table-management";
import { navToOrderEdit, navToPayment } from "../../services/order-common-service";
import ConfirmModal from "../modals/ConfirmModal";

/*
 * Please Note: If you want to enable multiselect, then props allowMultiSelect should be se to true.
 * By default it is false
 * */
function DinningPlace({ restaurantId, floorPlanId, tableArray, allowMultiSelect = false }) {
  const navigate = useNavigate();
  const { user, networkCall, setNetworkCall, showNotification, isSuperAdmin } = useUserStore();
  const { idWiseSelectedTables } = useTableManagementStorage();
  const [tables, setTables] = useState(tableArray);
  const [viewMode, setViewMode] = useState(CANVAS_CONSTANT.VIEW);
  const [showOrders, setShowOrders] = useState({
    show: false,
    orders: [],
  });
  const [saveBtnDisabled, setSaveBtnDisabled] = useState(true);
  const [selectedTableIds, setSelectedTableIds] = useState([]);
  const [isConfirmModalOpen, setIsConfirmModalOpen] = useState(false);
  const [selectedTableInfo, setSelectTableInfo] = useState({});

  async function addTableToFloorName(params) {
    const token = user.token.token;
    setNetworkCall(true);

    try {
      const res = await ApiService.ADD_TABLE_TO_FLOOR(params, token);
      if (!res || res.code !== 200) {
        showNotification(res?.message || "Failed to fetch restaurant branches");
        return;
      }
      setSaveBtnDisabled(true);
      setViewMode(CANVAS_CONSTANT.VIEW);
      showNotification("Layout Saved Successfully", false);
    } catch (err) {
      showNotification(err?.response?.data?.message || "Something went wrong");
    } finally {
      setNetworkCall(false);
    }
  }

  async function onHandleTableClean() {
    setNetworkCall(true);
    await tableCleanRequestSubmit(
      user.token.token,
      showNotification,
      restaurantId,
      floorPlanId,
      selectedTableInfo.tableId
    );
    setIsConfirmModalOpen(false);
    setNetworkCall(false);
  }

  /*Click events*/
  const onChangeTableLayout = (value) => {
    setTables(value);
    setSaveBtnDisabled(false);
  };

  const onSaveLayout = async () => {
    const params = {
      restaurantId: restaurantId,
      floor: {
        id: floorPlanId,
        tables,
      },
    };
    await addTableToFloorName(params);
  };

  const onChangeViewMode = (value) => {
    setViewMode(value);
  };

  const onClickTable = (value, allowMultiSelect = false) => {
    if (isSuperAdmin) {
      return;
    }

    const selectedTable = tableArray.find((item) => item.id === value);
    const tableInfo = {
      floorId: floorPlanId,
      tableId: selectedTable.id,
      tableName: selectedTable.name,
      status: SELECTED_TABLE_STATUS.DRAFT,
    };

    // For multi select only
    if (allowMultiSelect) {
      handleMultiActionsOnTableModal(showNotification, tableInfo, selectedTable);
      return;
    }

      updateFloorTabActiveKey(tableInfo.floorId);


    if (isCleanableATable(selectedTable.activeOrders)) {
      setSelectTableInfo(tableInfo);
      setIsConfirmModalOpen(true);
      return;
    }

    if (selectedTable.activeOrders.length === 1) {
      const orderInfo = selectedTable.activeOrders[0];
      orderInfo.orderStatus === 'Pending' ? navToPayment(navigate, orderInfo.orderId, 'TABLE') : navToOrderEdit(navigate, orderInfo.orderId, "TABLE", "No");
    } else if (selectedTable.activeOrders.length > 1) {
      setShowOrders({ ...showOrders, show: true, orders: selectedTable.activeOrders });
    } else {
      replaceSelectedTablesInStore([tableInfo], true);
      navigate(`/order/add?tablemanagement=Active&takeout=No&sourcePage=TABLE`);
    }
  };

  const onCancelOrderList = () => {
    setShowOrders({ ...showOrders, show: false, orders: [] });
  };
  /*Click events*/

  useEffect(() => {
    setSelectedTableIds(getSelectedTableIds(idWiseSelectedTables));
  }, [idWiseSelectedTables]);

  // Main purpose is to update table based on socket data.
  useEffect(() => {
    setTables(tableArray);
  }, [tableArray]);

  return (
    <div className="flex flex-col text-end">
      {isSuperAdmin && (
        <div className="w-full flex justify-between items-center mb-2">
          <div>Current Mode: {viewMode === CANVAS_CONSTANT.VIEW ? CANVAS_CONSTANT.VIEW : CANVAS_CONSTANT.EDIT}</div>
          {viewMode === CANVAS_CONSTANT.EDIT && (
            <button
              classNames="px-[6px]"
              loading={networkCall}
              disabled={saveBtnDisabled}
              className="bg-green ml-[12px] w-[120px] h-[42px] text-white font-ubold text-sm px-[12px] py-[8px] rounded"
              onClick={onSaveLayout}
            >
              Save Layout
            </button>
          )}

          <button
            className="bg-[#FFD700] ml-[12px]  h-[42px] text-black font-ubold text-sm px-[12px] py-[8px] rounded"
            onClick={() =>
              onChangeViewMode(viewMode === CANVAS_CONSTANT.VIEW ? CANVAS_CONSTANT.EDIT : CANVAS_CONSTANT.VIEW)
            }
          >
            Switch to {viewMode === CANVAS_CONSTANT.VIEW ? CANVAS_CONSTANT.EDIT : CANVAS_CONSTANT.VIEW} mode
          </button>
        </div>
      )}

      <Canvas
        tables={tables}
        mode={viewMode}
        onTablesChange={onChangeTableLayout}
        onModeChange={onChangeViewMode}
        onTableClick={onClickTable}
        allowMultiSelect={allowMultiSelect}
        selectedTableIds={selectedTableIds}
      />
      <ShowOrderModal
        openModal={showOrders.show}
        records={{ orders: showOrders.orders, onCancel: onCancelOrderList }}
      />
      <ConfirmModal
        isModalOpen={isConfirmModalOpen}
        centered
        records={{
          title: "Are you sure to clean table?",
          handleOk: onHandleTableClean,
          handleCancel: () => setIsConfirmModalOpen(false),
          confirmText: "Yes",
          cancelconfirmText: "No",
          customStyle: {
            top: 250,
          },
        }}
      ></ConfirmModal>
    </div>
  );
}

export default DinningPlace;
